/**
 * Clip scores reach the backoffice on two scales: the clippers write a 0–1
 * confidence, the rating on older records runs 0–10. Everything is read on the
 * 0–10 scale so a single set of thresholds colours them all.
 */
export function normalizeScore(score: number): number {
  return score <= 1 ? score * 10 : score;
}

/** `0.6084009493887423` → `6.1`. A header tag is no place for 16 decimals. */
export function formatScore(score: number): string {
  return normalizeScore(score).toFixed(1);
}

export function getScoreColor(score: number): string {
  const normalized = normalizeScore(score);
  if (normalized >= 8) return 'green';
  if (normalized >= 5) return 'orange';
  return 'default';
}
